import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class JobFullDetailsToolsButtonsMarkUnmarkJobAsHasAnIssue extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      apiUrlForToggleMarkJobAsHasAnIssue: "/api/v1/portal/jobs/mark-as/toggle/has-an-issue/",
      markedJobHasIssueReason:null
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }

  toggleMarkJobAsHasAnIssue() {
    if(!this.state.data.has_an_issue && !this.state.markedJobHasIssueReason){
      $('#infomodallabel').html('Add Reason');
      $('#infomodal .modal-body').html('Please add reason before mark job has an issue.');
      $('#infomodal').modal();
      return false;
    }
    return fetch(
      this.state.apiUrlForToggleMarkJobAsHasAnIssue+
      this.state.data.id,
      {
        method: "POST",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        body: JSON.stringify({marked_job_has_an_issue_reason: this.state.markedJobHasIssueReason}),
        headers: {
          "Authorization": 'Bearer ' + window.api_token,
          "Accept": 'application/json',
          "Content-Type": 'application/json',
        },
      }
    ).then((responseText) => {
        this.setState({markedJobHasIssueReason: null});
      }
    );
  }
  markedJobHasIssueReasonData(e){
    this.setState({markedJobHasIssueReason: e.target.value});
  }
  render() {
    return(
      <span>{(this.state.data.has_an_issue !== 1) ?
        <div><p>Job No issue</p>
         <p className="marked_jobs_has_anissue_div">
          <button
            className="btn btn-lg btn-dark job-row-highlighter-option-green"
            title="Toggle Mark Job as has an issue"
            onClick={
              (e) => this.toggleMarkJobAsHasAnIssue(e)
            }
          >
            Mark Job as Has An Issue
          </button>
          <textarea name="marked_job_has_an_issue_reason" value={this.state.markedJobHasIssueReason || ''} onChange={e => this.markedJobHasIssueReasonData(e)} placeholder="Enter Reason"></textarea>
          </p>
          </div>
        :
        <p>
          <button className="btn btn-lg has-an-issue">
            Job has an issue &nbsp;{
            (this.state.data.marked_as_has_an_issue_by !== null) ?
              <span>
                      {
                        this.state.data.marked_as_has_an_issue_by.first_name+' '+
                        this.state.data.marked_as_has_an_issue_by.last_name+
                        ' on '+
                        this.state.data.marked_as_has_an_issue_at
                      }
                  </span>
              : ''
          }
          </button>&nbsp;
          <button
            className="btn btn-lg btn-dark job-row-highlighter-option-green"
            onClick={(e) => this.toggleMarkJobAsHasAnIssue(e)}
          >
            <i className="fa fa-undo"></i>&nbsp;
            Unmark Job as Has An Issue
          </button>
          <div className="marked_job_has_issue_details">
                <p>
                  <strong>Marked By : </strong>
                  {(this.state.data.marked_as_has_an_issue_by && this.state.data.marked_as_has_an_issue_by.full_name)?this.state.data.marked_as_has_an_issue_by.full_name:null}
                </p>
                <p>
                  <strong>Marked Time : </strong>
                  {this.state.data.marked_as_has_an_issue_at}
                </p>
                <p>
                  <strong>Marked Reason : </strong>
                  {this.state.data.marked_job_has_an_issue_reason}
                </p>
              </div>
        </p>
      }
    </span>
    )
  }
}